import breadcrumb from "#templates/pages/breadcrumb";
import language from "#scripts/translation";
import "#components/hero.js";
// import formbricks from "@formbricks/js";

export const adminPageContent = () => {
  // Should return a promise

  setTimeout(() => {
    const contentElement = document.getElementById("contentHtml");
    contentElement.innerHTML = `
      <aim-hero></aim-hero>
      ${language("SITE_SETTINGS_PAGETITLE")}
    `;


  }, 1000); // 1000 milliseconds = 1 second

}

export const adminPage = () => {
  const breadcrumbHtml = breadcrumb();

  // Do stuff here ---
  // And update #contentHtml
  window.mgr.getUser().then((user) => {
    if (user || window.location.host.match(/localhost/gim)) {

      adminPageContent();
    } else {
      window.mgr.signinRedirect();
    }
  });

  return `
    <div class="container p-md-0">
      ${breadcrumbHtml}
    </div >
    <div class="container p-md-0 article" id="contentHtml">
      <div class="row">
        <div class="col-sm-12 text-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>`;
}
